import 'console-shim';
import React from 'react';
import ReactDOM from 'react-dom';
import root from 'window-or-global';
import {BrowserRouter} from 'react-router-dom';
import alt from './alt';
import {setLocale} from 'epic-common/src/locale';
import ScrollToTopOnUpdate from 'epic-react-common/src/components/ScrollToTopOnUpdate';
import App from './App';
import {LocalizationContext, mergeLocalizationDataAltStore} from 'epic-localization/src/context/LocalizationContext';

/**
 * The react app will look for a DOM element with this ID and insert itself there.
 */
const reactDomEle = root.document.getElementById('battleBreakersWrapper');
const i18nContext = mergeLocalizationDataAltStore(root.__epic_client_state.LocalizationStore);
const renderClient = function renderClient() {
    ReactDOM.hydrate((
        <BrowserRouter>
            <ScrollToTopOnUpdate>
                <LocalizationContext.Provider value={i18nContext}>
                    <App />
                </LocalizationContext.Provider>
            </ScrollToTopOnUpdate>
        </BrowserRouter>
    ), reactDomEle);
};

// only proceed if the react ele exists
if (reactDomEle) {
    if (root.__epic_client_state) {
        setLocale(root.__locale);
        alt.bootstrap(root.__epic_client_state);
    }
    renderClient();
}
